@import 'styles/mixins';

.counter {
  @include sm-regular;
  color: var(--dark-40);
}
